export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Мониторинг: Журнал обработки ТК",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
